const socials = [
  {
    platform: 'LinkedIn',
    handle: '@thl-the-hub-terminus-limited',
    description: 'Industry insights, company milestones, logistics trends, and career opportunities. Stay connected with the THL professional community.',
    cta: 'Follow on LinkedIn',
    href: 'https://www.linkedin.com/company/thl-the-hub-terminus-limited/',
    icon: 'ri-linkedin-box-fill',
    gradient: 'from-[#0077B5]/20 to-[#004471]/10',
    borderHover: 'hover:border-[#0077B5]/40',
    iconColor: '#0077B5',
    badge: 'Professional Network',
  },
  {
    platform: 'Instagram',
    handle: '@thlglobal_',
    description: 'Behind-the-scenes warehouse operations, delivery highlights, team moments, and visual stories from our fulfillment hubs across Nigeria.',
    cta: 'Follow on Instagram',
    href: 'https://www.instagram.com/thlglobal_',
    icon: 'ri-instagram-fill',
    gradient: 'from-[#E1306C]/20 to-[#833AB4]/10',
    borderHover: 'hover:border-[#E1306C]/40',
    iconColor: '#E1306C',
    badge: 'Visual Stories',
  },
  {
    platform: 'Facebook',
    handle: 'thehubterminuslimited',
    description: 'News, service updates, customer stories and community conversations. Join thousands of businesses following THL on Facebook.',
    cta: 'Follow on Facebook',
    href: 'https://www.facebook.com/thehubterminuslimited',
    icon: 'ri-facebook-box-fill',
    gradient: 'from-[#1877F2]/20 to-[#0a4f9e]/10',
    borderHover: 'hover:border-[#1877F2]/40',
    iconColor: '#1877F2',
    badge: 'Community Page',
  },
  {
    platform: 'X (Twitter)',
    handle: '@thlglobal_',
    description: 'Real-time logistics updates, industry commentary, quick takes and live news from THL. Follow us for the pulse of Nigerian supply chain.',
    cta: 'Follow on X',
    href: 'https://x.com/thlglobal_',
    icon: 'ri-twitter-x-line',
    gradient: 'from-white/10 to-white/5',
    borderHover: 'hover:border-white/30',
    iconColor: '#e5e5e5',
    badge: 'Latest Updates',
  },
];

export default function BlogPreviewSection() {
  return (
    <section className="py-24 px-6" style={{ background: '#0f0f18' }}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <p className="eyebrow">Follow Us</p>
          <h2 className="section-heading mb-2">Connect With THL</h2>
          <p className="section-lead max-w-xl mx-auto">
            Stay in the loop: updates, stories, and logistics insights from our team, delivered straight to your feed.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {socials.map(s => (
            <div
              key={s.platform}
              className={`bg-thl-dark3 border border-thl-border ${s.borderHover} rounded-xl overflow-hidden transition-all duration-300 group flex flex-col`}
            >
              {/* Card header gradient */}
              <div className={`h-28 bg-gradient-to-br ${s.gradient} flex items-center justify-center relative`}>
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/5 border border-white/10">
                  <i className={`${s.icon} text-4xl`} style={{ color: s.iconColor }} />
                </div>
              </div>

              {/* Card body */}
              <div className="p-6 flex flex-col flex-1 text-center">
                <span className="text-xs font-semibold px-3 py-0.5 rounded-full border border-thl-border text-white/40 mx-auto mb-3">
                  {s.badge}
                </span>
                <h3 className="text-white font-bold text-lg mb-1">{s.platform}</h3>
                <p className="text-white/40 text-xs mb-4">{s.handle}</p>
                <p className="text-white/55 text-sm leading-relaxed flex-1 mb-6">{s.description}</p>
                <a
                  href={s.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="block w-full text-center text-sm font-semibold py-2.5 px-4 rounded-lg border border-thl-border text-white/70 hover:text-white hover:border-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  style={{ textDecoration: 'none' }}
                >
                  {s.cta} <span className="ml-1">→</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
